/**
 * @generated SignedSource<<03f000e3b68e5b4f0b372764d13afb3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailContent_signal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailContentMain_signal" | "SignalDetailFooterTV_signal" | "SignalDetailImages_signal">;
  readonly " $fragmentType": "SignalDetailContent_signal";
};
export type SignalDetailContent_signal$key = {
  readonly " $data"?: SignalDetailContent_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailContent_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalDetailContent_signal",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalDetailContentMain_signal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalDetailFooterTV_signal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalDetailImages_signal"
    }
  ],
  "type": "Signal",
  "abstractKey": null
};

(node as any).hash = "8380e451579b52ebd298c5997735e8c3";

export default node;
